import { useEffect, useState } from 'react';
import { api } from './api';

const PERIODS = [
  { key: 'week', label: 'Tuần' },
  { key: 'month', label: 'Tháng' },
];

export default function AnalyticsPage() {
  const [period, setPeriod] = useState('month');
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setError('');
    api.getAnalytics(period)
      .then(setData)
      .catch(() => setError('Không tải được dữ liệu analytics.'))
      .finally(() => setLoading(false));
  }, [period]);

  const maxViews = data ? Math.max(...data.daily.map((d) => d.pageViews), 1) : 1;

  return (
    <div className="analytics-page">
      <div className="analytics-header">
        <h2>Thống kê truy cập</h2>
        <div className="analytics-period-tabs">
          {PERIODS.map((p) => (
            <button
              key={p.key}
              className={`analytics-period-btn${period === p.key ? ' active' : ''}`}
              onClick={() => setPeriod(p.key)}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>
      <p className="analytics-subtitle">{period === 'week' ? '7 ngày qua' : '30 ngày qua'}</p>

      {loading ? (
        <div className="analytics-loading">Đang tải…</div>
      ) : error ? (
        <div className="analytics-error">{error}</div>
      ) : data && (
        <>
          <div className="analytics-cards">
            <div className="analytics-card">
              <span className="analytics-card-value">{data.totalPageViews.toLocaleString('vi-VN')}</span>
              <span className="analytics-card-label">Lượt xem trang</span>
            </div>
            <div className="analytics-card">
              <span className="analytics-card-value">{data.totalActiveUsers.toLocaleString('vi-VN')}</span>
              <span className="analytics-card-label">Người dùng</span>
            </div>
            <div className="analytics-card">
              <span className="analytics-card-value">{data.totalSessions.toLocaleString('vi-VN')}</span>
              <span className="analytics-card-label">Phiên</span>
            </div>
          </div>

          {data.daily.length > 0 ? (
            <div className="analytics-chart-wrap">
              <h3>Lượt xem trang theo ngày</h3>
              <div className="analytics-chart">
                {data.daily.map((d) => (
                  <div key={d.date} className="analytics-bar-col" title={`${d.date}: ${d.pageViews} lượt xem`}>
                    <div className="analytics-bar" style={{ height: `${Math.round((d.pageViews / maxViews) * 100)}%` }} />
                    <span className="analytics-bar-label">{d.date.slice(8)}</span>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <p className="analytics-empty">Chưa có dữ liệu. GA4 cần vài giờ để bắt đầu thu thập.</p>
          )}
        </>
      )}
    </div>
  );
}
